// Remembers where a signed-out visitor was headed (e.g. a shared
// /app/capital/apply link) so we can send them there right after they
// sign in / sign up instead of dumping them on the home page.
const KEY = 'founderos_post_auth_redirect';

export const savePostAuthRedirect = (path) => {
  try {
    if (path && path.startsWith('/app') && path !== '/app' && path !== '/app/') {
      localStorage.setItem(KEY, path);
    }
  } catch { /* storage unavailable — silently skip */ }
};

export const consumePostAuthRedirect = () => {
  try {
    const v = localStorage.getItem(KEY);
    if (v) localStorage.removeItem(KEY);
    return v || null;
  } catch {
    return null;
  }
};
